import { useQuery } from '@apollo/client';
import { faLink } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ApolloProviderV4 } from '~/apollo/client-v4';
import { graphql } from '~/apollo/generated/v4';
import { NotFound } from '~/components/common/NotFound';
import { Panel } from '~/components/common/Panel';
import { SpinnerPlaceholder } from '~/components/common/SpinnerPlaceholder';
import { Button } from '~/components/ui/button';
import { CreateLithostratStudyLinkModalV4 } from '~/components/upload/lithostrat/lithostrat-link/create-lithostrat-study-link';
import { StudyLithostratLinksTable } from '~/components/upload/lithostrat/lithostrat-link/lithostrat-study-links-table';
import { useRouteParam } from '~/hooks/routing';
import { createRefetchQueries } from '~/utils/graphql';

const LITHOSTRATIGRAPHY_TAB = graphql(`
  query UploadStudyUpdateLithostratigraphyTab($id: ID!) {
    studyGet(id: $id) {
      id
      lithostratStudyLinks {
        ...lithostratStudyLinkParts
      }
    }
  }
`);

export default function UpdateStudyLithostratigraphyPage() {
  return (
    <ApolloProviderV4>
      <UpdateStudyLithostratigraphyPageInner />
    </ApolloProviderV4>
  );
}

function UpdateStudyLithostratigraphyPageInner() {
  const studyId = useRouteParam('studyId', parseInt);

  const { data, loading } = useQuery(LITHOSTRATIGRAPHY_TAB, {
    variables: { id: studyId },
  });

  const refetchQueries = createRefetchQueries([
    {
      query: LITHOSTRATIGRAPHY_TAB,
      variables: { id: studyId },
    },
  ]);

  const study = data?.studyGet;
  const lithostratLinks = study?.lithostratStudyLinks ?? [];

  if (loading) return <SpinnerPlaceholder />;
  if (!study) return <NotFound />;

  return (
    <Panel>
      <Panel.Heading className="flex justify-between">
        <Panel.Title>Lithostrat Links</Panel.Title>
        <CreateLithostratStudyLinkModalV4
          studyId={studyId}
          refetchQueries={refetchQueries}
        >
          {showModal => (
            <Button
              type="button"
              color="primary"
              size="xs"
              onClick={showModal}
              startIcon={<FontAwesomeIcon icon={faLink} />}
            >
              Create Link
            </Button>
          )}
        </CreateLithostratStudyLinkModalV4>
      </Panel.Heading>
      <Panel.Body>
        {!loading && (
          <StudyLithostratLinksTable
            lithostratLinks={lithostratLinks}
            refetchQueries={refetchQueries}
          />
        )}
      </Panel.Body>
    </Panel>
  );
}
